import cn from "classnames";
import moment from "moment";
import React, { Component } from 'react';
import TaskStatus from './TaskStatus'
import TaskIcon from './TaskIcon'
import "./style.css";
import { Arrow, Edit } from '../../icons';
import TaskPriority from "./TaskPriority";

const formatUser = user => user ? `${user.user_title} ${user.user_firstname} ${user.user_lastname}` : ''
const formatDue = due => moment(due).format('MMM D')

class TaskListItem extends Component {

  state = {
    open: false
  }

  toggleOpen = () => {
    this.setState({ open: !this.state.open })
  }

  render() {
    const { open } = this.state;
    const { task, onEdit } = this.props;
    return (
      <div className="task">
        <div className="task-title-row">
          <TaskIcon status={task.task_status} />
          <div className="task-title">
            {task.task_title}
          </div>
          <TaskPriority priority={task.task_priority} />
          <div className="align-right">
            <TaskStatus status={task.task_status} />
            <button
              className="open-button"
              onClick={this.toggleOpen}
            >
              <div className={cn({ ArrowFliped: open }, "Arrow")}>
                <Arrow />
              </div>
            </button>
          </div>
        </div>
        <div className="task-assigned-row">
          <div>
            <div className="task-assigned-label">
              Assigned to
          </div>
            <div className="task-assigned-name">
              {formatUser(task.recipient)}
            </div>

          </div>
          <div>
            {formatDue(task.task_due)}
          </div>
        </div>
        {open && <div className="task-description-row">
          <div className="task-description-label">Description</div>
          <div>
            {task.task_note}
          </div>
        </div>}
        <div className="task-created-row">
          <div>
            Created by <span className="task-created-name">{formatUser(task.originator)}</span>
          </div>
          <div>
            <button
              className="open-button"
              onClick={() => onEdit(task)}
            >
              <div className="task-edit-icon">
                <Edit />
              </div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default TaskListItem;



// WEBPACK FOOTER //
// ./src/components/TaskListItem/index.js